(()=>{
  const desktop=matchMedia('(min-width:750px)');
  const init=(scope=document)=>{
    scope.querySelectorAll('[data-pk-detail-fill-data]').forEach(data=>{
      const product=document.querySelector('.pk-product-collector');
      const left=product?.querySelector('.product__media-wrapper');
      const right=product?.querySelector('.product__info-wrapper');
      if(!left||!right||product.dataset.pkDetailFillReady)return;
      let source;try{source=JSON.parse(data.textContent);}catch{return;}
      product.dataset.pkDetailFillReady='true';
      const imageName=src=>{try{return new URL(src,location.href).pathname.split('/').pop()}catch{return src}};
      const distinctVariantImages=new Set(source.variants.map(item=>item.image).filter(Boolean)).size>1;
      const styleAllows=(selected,image)=>{
        if(source.styles?.[selected])return source.styles[selected].images.includes(imageName(image.src));
        const variant=source.variants.find(item=>String(item.id)===selected);
        return !distinctVariantImages||!variant?.image||imageName(image.src)===imageName(variant.image);
      };
      const syncMergedStyle=()=>{
        if(source.styles)product.dataset.pkMerged='true';
        const selected=String(product.querySelector('form[action*="/cart/add"] [name="id"]')?.value||source.selected);
        document.querySelectorAll('[data-pk-merged-style]').forEach(section=>{
          const hidden=section.dataset.pkMergedStyle!==selected;
          if(section.hidden!==hidden)section.hidden=hidden;
        });
        const variant=source.variants.find(item=>String(item.id)===selected);
        if(variant?.image){
          product.querySelectorAll('media-gallery .product__media img').forEach(img=>{
            const active=imageName(img.getAttribute('src'))===imageName(variant.image);
            if(active)img.loading='eager';
            img.fetchPriority=active?'high':'auto';
          });
        }
        const input=product.querySelector('quantity-input input[name="quantity"]');
        if(!input||!variant)return;
        const limited=!!variant.tracked&&variant.policy==='deny';
        const stockMax=limited?Math.max(0,variant.quantity-Number(input.dataset.cartQuantity||0)):null;
        const max=variant.ruleMax==null?stockMax:stockMax==null?variant.ruleMax:Math.min(stockMax,variant.ruleMax);
        if(max!==null){
          if(input.getAttribute('max')!==String(max))input.setAttribute('max',String(max));
          if(max>0&&Number(input.value)>max){input.value=String(max);input.dispatchEvent(new Event('change',{bubbles:true}));}
        }else if(input.hasAttribute('max'))input.removeAttribute('max');
        const plus=input.closest('quantity-input')?.querySelector('[name="plus"]');
        if(plus){const disabled=max!==null&&Number(input.value)>=max;plus.disabled=disabled;plus.classList.toggle('disabled',disabled);}

      };
      const hideBrokenDetailImage=img=>{if(img.matches('.pk-dzi-style-gallery img')&&img.complete&&!img.naturalWidth){img.hidden=true;img.style.display='none';}};
      product.querySelectorAll('.pk-dzi-style-gallery img').forEach(img=>{hideBrokenDetailImage(img);img.addEventListener('error',()=>hideBrokenDetailImage(img));});
      const columns=[left,right];
      const galleries=columns.map(column=>{column.classList.add('pk-detail-fill-column');const gallery=document.createElement('div');gallery.className='pk-detail-fill';column.append(gallery);return gallery;});
      const contentBottom=element=>{
        if(element.matches('.pk-detail-fill,script,style,template')||element.hidden)return -Infinity;
        const rect=element.getBoundingClientRect(),style=getComputedStyle(element);
        if(!rect.width||!rect.height||style.display==='none'||style.visibility==='hidden'||style.position==='absolute'||style.position==='fixed')return -Infinity;
        if(element.matches('details:not([open])'))return element.querySelector(':scope > summary')?.getBoundingClientRect().bottom??-Infinity;
        if(element.matches('img,video,iframe,button,input,select,textarea,h1,h2,h3,h4,h5,h6,p,summary'))return rect.bottom;
        const children=[...element.children].filter(child=>{const r=child.getBoundingClientRect();return r.right>rect.left&&r.left<rect.right;});
        const ends=children.map(contentBottom).filter(Number.isFinite);
        if(!ends.length)return element.textContent.trim()?rect.bottom:-Infinity;
        return Math.max(...ends)+(parseFloat(style.paddingBottom)||0)+(parseFloat(style.borderBottomWidth)||0);
      };
      const fillCraft=()=>{
        const pendingCraft=[...new Set([...product.querySelectorAll('.pk-dzi-merchants [data-pk-media-slot="craft"],.pk-dzi-track.pk-detail-craft-fallback')].map(node=>{let track=node.closest('.pk-dzi-track');if(!track){track=document.createElement('div');track.className='pk-dzi-track';node.replaceWith(track);}return track;}).filter(Boolean))];
        const selected=String(product.querySelector('form[action*="/cart/add"] [name="id"]')?.value||source.selected);
        const variant=source.variants.find(item=>String(item.id)===selected);
        const attached=new Set(source.variants.map(item=>item.image).filter(Boolean));
        const images=[...new Map(source.images.filter(image=>styleAllows(selected,image)&&(!attached.has(image.src)||image.src===variant?.image)).map(image=>[image.src,image])).values()].slice(0,2);
        const imagePath=src=>{try{return new URL(src,location.href).pathname}catch{return src}};
        const cached=new Map([...product.querySelectorAll('.product__media-wrapper img')].filter(img=>!img.closest('.pk-detail-fill,.pk-detail-craft-fallback')&&img.complete&&img.naturalWidth>=300).map(img=>[imagePath(img.currentSrc||img.src),img.currentSrc||img.src]));
        const resolved=images.map(image=>cached.get(imagePath(image.src))||image.src);
        const placeholder=images.map(image=>cached.get(imagePath(image.src))).find(Boolean);
        const key=JSON.stringify([selected,resolved,placeholder]);
        pendingCraft.forEach(track=>{
          if(track.dataset.pkCraftVariant===key&&!track.querySelector('[data-pk-media-slot="craft"]'))return;
          track.classList.add('pk-detail-craft-fallback');track.replaceChildren();
          images.forEach((image,index)=>{const card=document.createElement('figure'),img=document.createElement('img');card.className='pk-dzi-card pk-dzi-card--portrait';if(placeholder){card.style.backgroundImage=`url("${placeholder}")`;card.style.backgroundSize='contain';card.style.backgroundPosition='center';card.style.backgroundRepeat='no-repeat';}img.addEventListener('load',()=>{card.style.backgroundImage='none';},{once:true});img.src=resolved[index];img.alt=image.alt||source.title;img.width=1440;img.height=1440;img.loading='eager';card.append(img);track.append(card);});
          track.hidden=!images.length;track.dataset.pkCraftVariant=key;
        });
      };
      const failed=new Set();
      let queued=false,lastKey='';
      const render=()=>{
        queued=false;
        syncMergedStyle();
        galleries.forEach(gallery=>gallery.removeAttribute('data-active'));
        if(!desktop.matches)return;
        fillCraft();
        const ends=columns.map(contentBottom);
        if(!ends.every(Number.isFinite))return;
        const difference=Math.abs(ends[0]-ends[1]);
        if(difference<=1)return;
        const form=product.querySelector('form[action*="/cart/add"]');
        const selected=String(form?.querySelector('[name="id"]')?.value||source.selected);
        const variant=source.variants.find(item=>String(item.id)===selected);
        const attached=new Set(source.variants.map(item=>item.image).filter(Boolean));
        const eligible=source.images.filter(image=>styleAllows(selected,image)&&!failed.has(image.src)&&(!attached.has(image.src)||image.src===variant?.image));
        const available=[...new Map(eligible.map(image=>[image.src,image])).values()].slice(0,4);
        const path=src=>{try{return new URL(src,location.href).pathname}catch{return src}};
        const cached=new Map([...product.querySelectorAll('.product__media-wrapper img')].filter(img=>!img.closest('.pk-detail-fill')&&img.complete&&img.naturalWidth>=300).map(img=>[path(img.currentSrc||img.src),img.currentSrc||img.src]));
        const placeholder=available.map(image=>cached.get(path(image.src))).find(Boolean);
        let images=available;
        if(!images.length)return;
        const index=ends[0]<ends[1]?0:1,column=columns[index],gallery=galleries[index];
        const targetBottom=Math.max(...ends,...columns.map(item=>item.getBoundingClientRect().bottom));
        const fillHeight=targetBottom-ends[index],fillWidth=column.getBoundingClientRect().width;
        const compact=fillHeight<80;
        let layout={count:1,columns:1,rows:1,score:Infinity};
        for(const count of [1,2,4].filter(count=>count<=available.length)){
          for(const columnCount of [1,2].filter(number=>number<=count)){
            const rows=count/columnCount;
            const ratio=(fillWidth/columnCount)/(fillHeight/rows);
            const score=Math.abs(Math.log(ratio));
            if(score<layout.score)layout={count,columns:columnCount,rows,score};
          }
        }
        images=compact?[]:available.slice(0,layout.count);
        gallery.toggleAttribute('data-compact',compact);
        gallery.style.gridTemplateColumns=`repeat(${layout.columns},minmax(0,1fr))`;
        gallery.style.gridTemplateRows=`repeat(${layout.rows},minmax(0,1fr))`;
        const key=JSON.stringify([selected,compact,images.map(image=>cached.get(path(image.src))||image.src),placeholder]);
        if(lastKey!==key||(!compact&&!gallery.children.length)){
          galleries.forEach(item=>item.replaceChildren());
          images.forEach(image=>{const link=document.createElement('a'),img=document.createElement('img');link.href=image.src;link.target='_blank';link.rel='noopener';if(placeholder){link.style.backgroundImage=`url("${placeholder}")`;link.style.backgroundPosition='center';link.style.backgroundSize='contain';link.style.backgroundRepeat='no-repeat';}
          img.src=cached.get(path(image.src))||image.src;img.alt=image.alt||source.title;img.loading='eager';img.decoding='async';img.addEventListener('load',()=>{link.style.backgroundImage='none';},{once:true});img.addEventListener('error',()=>{failed.add(image.src);lastKey='';schedule();},{once:true});link.append(img);gallery.append(link);});
          lastKey=key;
        }
        const columnRect=column.getBoundingClientRect();
        const border=parseFloat(getComputedStyle(column).borderTopWidth)||0;
        gallery.style.setProperty('--pk-fill-top',`${ends[index]-columnRect.top-border}px`);
        gallery.style.setProperty('--pk-fill-height',`${fillHeight}px`);
        gallery.dataset.count=String(images.length);
        gallery.setAttribute('data-active','');
      };
      const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(render);}};
      const observer=new ResizeObserver(schedule);
      columns.forEach(column=>{observer.observe(column);[...column.children].filter(e=>!e.matches('.pk-detail-fill')).forEach(e=>observer.observe(e));});
      product.addEventListener('load',schedule,true);
      product.addEventListener('loadedmetadata',schedule,true);
      product.addEventListener('change',schedule);
      product.addEventListener('toggle',schedule,true);
      product.addEventListener('animationend',schedule,true);
      product.addEventListener('transitionend',schedule,true);
      if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
        subscribe(PUB_SUB_EVENTS.variantChange,({data:event})=>{
          if(String(event?.sectionId)!==product.closest('product-info')?.dataset.section)return;
          const fresh=event.html?.querySelector('[data-pk-detail-fill-data]');
          if(fresh){try{source=JSON.parse(fresh.textContent);}catch{}}
          schedule();
        });
      }
      document.addEventListener('variant:change',schedule);
      document.addEventListener('product:variant-change',schedule);
      desktop.addEventListener('change',schedule);
      window.addEventListener('resize',schedule,{passive:true});
      const mutation=new MutationObserver(schedule);
      mutation.observe(product,{subtree:true,childList:true,characterData:true});
      document.fonts?.ready.then(schedule);
      schedule();
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',()=>init());
})();
